import TemplateScreen from "src/pages/templates/template";

const AgentTemplatesTab = () => {
  return (
    <div className="">
      <TemplateScreen />
    </div>
  );
};

export default AgentTemplatesTab;
